import { getSessionStorageItem } from "../SessionStorageMethod/getSessionStorageItem";
import moment from "moment-timezone";
import { showToast } from "ui-components";
import { t } from "i18next";
import { setSessionStorageItem } from "../SessionStorageMethod/setSessionStorageItem";
import { v4 as uuidv4 } from "uuid";
import { getAssessmentDetailsByAssessementId } from "../../service/Scope/Scope";
import { removeSessionStorageItem } from "../SessionStorageMethod/removeSessionStorageItem";
import { ResponseScreenEnums } from "../Enums/ResponseScreenEnums";
import { getSkillsForLevels } from "../../service/CvScanning/CvScanning";
import { APIClient, getEntireCustomUrl } from "smartassess-api-lib";
// ar: Arabic he: Hebrew fa: Persian (Farsi) ur: Urdu
const rtlLanguages = ["ar", "he", "fa", "ur"]; // Add other RTL languages if needed

export const isRtl = (language: string) => rtlLanguages.includes(language);

// check component disability
export const isDisable = (functionBehavior: any) => {
  return functionBehavior === "disable" ? true : false;
};

// check component hidden or not
export const isHide = (functionBehavior: any) => {
  return functionBehavior === "hide" ? false : true;
};

export const addDisableCss = (functionBehavior: any) => {
  return functionBehavior === "disable" ? "addDisableCss" : "";
};

// find value for render
export const findValuesForKey = (
  arrayData: any,
  keyName: string,
  keyToFind: string | number,
) => {
  // Extract all scope arrays
  const filteredArray = (arrayData || [])
    .map((item: any) => item[keyName])
    .filter(Boolean);

  // Function to find the value for a specific key in a scope array
  const findValueForKey = (filterArray: any, key: string | number) => {
    const scopeItem = filterArray.find((item: any) => key in item);
    return scopeItem ? scopeItem[key] : undefined;
  };

  // Iterate through each scope array and find the value for the specified key
  const valuesForGivenKey = filteredArray
    .map((filterArray: any) => findValueForKey(filterArray, keyToFind))
    .filter(Boolean);
  return valuesForGivenKey[0] || null;
};

export function determinePageType(url: string) {
  try {
    const pathname = url.toLowerCase();
    if (pathname.includes("template")) {
      return 0; // Scope available in URL
    } else if (pathname.includes("build")) {
      return 1; // Setting available in URL
    } else if (pathname.includes("custom")) {
      return 2; // Setting available in URL
    } else if (pathname.includes("setting")) {
      return 3; // Setting available in URL
    } else if (pathname.includes("review")) {
      return 4; // Review available in URL
    } else {
      return 1; // None of the keywords found
    }
  } catch (error) {
    console.error("Invalid URL:", error);
    return 1; // Invalid URL
  }
}

// Custom validation function
export const validateDuplicateDifficulty = (arr: any) => {
  const uniqueSkillLevelPairs = new Set();
  for (const item of arr) {
    const pair = `${item.skillName}_${item.difficultyLevel}`;
    if (uniqueSkillLevelPairs.has(pair)) {
      return true; // Duplicate pair found
    }
    uniqueSkillLevelPairs.add(pair);
  }
  return false; // No duplicate pairs found
};
// Validate the array
export const initialScopeData = {
  type: getSessionStorageItem("Type") || "Hiring",
  titleHeadContent: getSessionStorageItem("titleHeadContent") || "",
};

export const initialSettingData = {
  type: getSessionStorageItem("Type") || "",
  titleHeadContent: getSessionStorageItem("titleHeadContent") || "",
  positionsCount: 0,
};

export const initialInviteData = {
  inviteEmail: "",
};

// user login User Data
export const loginUserData = {
  email: "",
  password: "",
  otp: "",
  confirmPassword: "",
  oldPassword: "",
};

export const completeProfileData = {
  logo: "",
  companyName: "",
  industryType: "",
  displayName: "",
  websiteUrl: "",
  mobile: "",
  searchLocation: "",
  address: "",
  otherAddress: "",
  country: "",
  state: "",
  city: "",
  zipcode: "",
  latitude: "",
  longitude: "",
  linkedin: "",
  twitter: "",
  facebook: "",
  instagram: "",
  ownerFirstName: "",
  ownerLastName: "",
  ownerDesignation: "",
  ownerEmail: "",
  ownerMobile: "",
};

export const minuteOptions = (minLabel: string) => {
  const options = [];
  for (let i = 1; i <= 15; i++) {
    options.push({ value: i, label: `${i} ${minLabel}${i !== 1 ? "s" : ""}` });
  }
  return options;
};

export const initialReviewData = {
  type: getSessionStorageItem("Type") || "",
  titleHeadContent: getSessionStorageItem("titleHeadContent") || "",
};

// check the anwer check while creating custom questions
export const isAnswerSetValid = (data: any, additionCheck: boolean = false) => {
  if (data?.type == "Single" || data?.type == "Multiple") {
    if (Array.isArray(data.answerSet)) {
      for (const answer of data.answerSet) {
        // Check if label has some value or image is present with some value
        if (
          (answer?.label &&
            answer?.label.trim() !== "" &&
            (additionCheck ? answer?.label?.length < 1000 : true)) ||
          (answer?.image !== null && answer?.image !== undefined)
        ) {
          // Move to the next object if the condition is met
          continue;
        } else {
          // If label has no value or image is not present and has a null value, return false
          return false;
        }
      }
    } else {
      // If answerSet is not an array, return false
      return false;
    }
  }
  // if (data.type === "Essay" || data.type === "Video") {
  //   // Check if answerSet is a non-empty string
  //   if (
  //     typeof data.answerSet === "string" &&
  //     data.answerSet.trim() !== "" &&
  //     (additionCheck ? data?.answerSet?.length < 1000 : true)
  //   ) {
  //     return true;
  //   } else {
  //     // If answerSet is not a valid string, return false
  //     return false;
  //   }
  // }

  // If all objects pass the conditions, return true
  return true;
  // }
};

interface InputValue {
  id: string;
  label: string;
  selected: boolean;
  image: string | null;
}

interface InputValueOne {
  Single: InputValue[];
  Multiple: InputValue[];
  Essay: string;
  Video: string;
}

// check Should Add InputValue
export function checkShouldAddInputValue(
  inputValueOne: InputValueOne,
  inputValueType: keyof InputValueOne,
): boolean {
  const values = inputValueOne[inputValueType];
  if (Array.isArray(values)) {
    return values.every(
      (item) =>
        item.label.trim() !== "" ||
        (item.image !== undefined && item.image !== null),
    );
  }
  return false;
}

// Transform existing tempalte data
export const transformExistingTempalteData = (data: any) => {
  const tranformData = [];
  if (data?.length) {
    for (let i = 0; i < data?.length; i++) {
      const tempData = {
        subjectFieldSet: data[i]?.assessmentTemplateSkills?.map(
          (item: any) => ({
            skillId: item?.skillId,
            skillIcon: item?.skillIcon,
            difficultyLevel: item?.difficultyLevel,
            title: item?.skillName,
            questionsCount: Number(item?.totalQuestions),
            questionNo: Number(item?.totalQuestions),
            selectedDifficultyLevels: {
              [item?.difficultyLevel]: Number(item?.totalQuestions),
            },
            questionType: item?.questionType,
            indiAssessTime: `${calculatTotalTimeOfSkill(item?.questionType, Number(item?.totalQuestions))} mins`,
          }),
        ),
        assessmentTitle: data[i]?.title,
        aboutAssess: "About test 01",
        description: "",
        skills: data[i]?.assessmentTemplateSkills?.length,
        // experienceLevel: `${data[i]?.minimumExperience ?? 3} Years - ${
        //   data[i]?.maximumExperience ?? 5
        // } Years`,
        // timeLimit: `${totalQuestion(data[i]?.assessmentTemplateSkills) * 3} mins`,
        // questions: totalQuestion(data[i]?.assessmentTemplateSkills),
        timeLimit: `${data[i]?.totalTime} mins`,
        questions: data[i]?.totalQuestions,
        assessmentId: data[i]?.assessmentTemplateId,
        // isPublic: data[i]?.isPublic,
      };
      tranformData.push(tempData);
    }
    return tranformData;
  }
  return [];
};

// tranform answer set
export const transformAnswerSet = (inputData: any) => {
  const updateAssessmentQuestions = [];
  for (let i = 0; i < inputData?.length; i++) {
    if (inputData[i].type === "Essay") {
      const essayData = inputData[i];
      essayData.customQuestion = true;
      essayData.attachment = inputData[i]?.image?.ImageUrl;
      essayData.correctOptions = inputData[i]?.answerSet;
      essayData.reference = inputData[i]?.reference;
      delete inputData[i]?.answerSet;
      delete inputData[i]?.image;
      updateAssessmentQuestions.push(essayData);
    } else if (inputData[i]?.type === "Video") {
      const videoData = inputData[i];
      videoData.customQuestion = true;
      videoData.attachment = inputData[i]?.image?.ImageUrl;
      videoData.correctOptions = inputData[i]?.answerSet;
      videoData.reference = inputData[i]?.reference;
      delete inputData[i]?.answerSet;
      delete inputData[i]?.image;
      updateAssessmentQuestions.push(videoData);
    } else if (inputData[i]?.type !== "template") {
      const answerOptions = inputData[i]?.answerSet
        .filter((item: any) => item) // Filter items where selected is false
        .map((item: any) => ({
          option: item?.label,
          attachment: item?.image?.fileName || null,
        })); // Map to the desired format

      const correctOptions = inputData[i]?.answerSet
        .filter((item: any) => item?.selected) // Filter items where selected is true
        .map((item: any) => ({
          option: item?.label,
          attachment: item?.image?.ImageUrl || null,
        })); // Map to the desired format
      const UpdateObj = {
        question: inputData[i]?.question || null,
        type: inputData[i]?.type || null,
        attachment: inputData[i]?.image?.ImageUrl || null,
        timeLimit: inputData[i]?.timeLimit || null,
        totalQuestions: inputData[i]?.questionsCount,
        customQuestion: true,
        answerOptions,
        correctOptions,
        reference: inputData[i]?.reference,
      };
      updateAssessmentQuestions.push(UpdateObj);
    } else {
      // this run when template selected
      const {
        difficultyLevel,
        totalQuestions,
        skillId,
        skillName,
        type,
        questionType,
        skillKeywords,
      } = inputData[i];
      const finalObj = {
        difficultyLevel,
        totalQuestions: totalQuestions,
        skillId,
        skillName,
        type,
        questionType,
        skillKeywords,
      };
      updateAssessmentQuestions.push(finalObj);
    }
  }
  // removed the object in which  totalQuestions  is 0
  return updateAssessmentQuestions.filter((item) => item.totalQuestions !== 0);
};
// function to get assessement path as per steps
export function getAssessmentPath(
  stepNumber: number,
  tempUniqueId: undefined | string | number,
  currentLanguage: string,
  editedParams?: string | null,
  jobId?: string | null,
): string {
  switch (stepNumber) {
    // case 1:
    //   return `/${currentLanguage}/assessment/template/${tempUniqueId}${editedParams ? "?edited=true" : ""}${editedParams && jobId ? `&jobId=${jobId}` : jobId ? `?jobId=${jobId}` : ""}`;
    case 1:
      return `/${currentLanguage}/assessment/build/${tempUniqueId}${editedParams ? "?edited=true" : ""}${editedParams && jobId ? `&jobId=${jobId}` : jobId ? `?jobId=${jobId}` : ""}`;
    case 2:
      return `/${currentLanguage}/assessment/custom/${tempUniqueId}${editedParams ? "?edited=true" : ""}${editedParams && jobId ? `&jobId=${jobId}` : jobId ? `?jobId=${jobId}` : ""}`;
    case 3:
      return `/${currentLanguage}/assessment/settings/${tempUniqueId}${editedParams ? "?edited=true" : ""}${editedParams && jobId ? `&jobId=${jobId}` : jobId ? `?jobId=${jobId}` : ""}`;
    case 4:
      return `/${currentLanguage}/assessment/review/${tempUniqueId}${editedParams ? "?edited=true" : ""}${editedParams && jobId ? `&jobId=${jobId}` : jobId ? `?jobId=${jobId}` : ""}`;
    default:
      return `/${currentLanguage}/assessment/default`;
  }
}

export function calculateMinusAmount(
  increasingValue: number,
  lastCount: number,
) {
  return lastCount - increasingValue;
}

// Utility function to format the timer value into minutes and seconds
export const formatTime = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

export const handleKeyPressSearch = (
  e: React.KeyboardEvent<HTMLInputElement>,
) => {
  if (e.key === "Enter") {
    e.preventDefault(); // Prevent default form submission on Enter key
  }
};

interface ItemId {
  id: number;
  // Other properties if any
}

export function sortArr2ByArr1(arr1: ItemId[], arr2: ItemId[]): ItemId[] {
  if ((arr1 || []).length !== (arr2 || []).length) {
    return arr2;
  }

  // Create a map to store the index of each ID in arr1
  const idIndexMap: Map<number, number> = new Map();
  (arr1 || []).forEach((item, index) => {
    idIndexMap.set(item.id, index);
  });

  // Sort arr2 based on the index of IDs in arr1
  (arr2 || []).sort((a, b) => {
    const indexA = idIndexMap.get(a.id);
    const indexB = idIndexMap.get(b.id);
    // If either ID is not found in arr1, sort them based on their original order
    if (indexA === undefined && indexB === undefined) {
      return 0; // No change in order
    } else if (indexA === undefined) {
      return 1; // Move b ahead of a
    } else if (indexB === undefined) {
      return -1; // Move a ahead of b
    }
    return indexA - indexB; // Sort based on the index in arr1
  });

  return arr2;
}

// text to speak function
export function TextToSpeakMessage(message: string, callback: () => void) {
  const speech: any = new SpeechSynthesisUtterance(message);
  speech.voice = window.speechSynthesis.getVoices()[10];
  speechSynthesis.speak(speech);
  // Call the callback function after the message has been spoken
  speech.onend = callback;
}

export const convertDate = (
  dateTime: string,
  withComma?: boolean,
  withTime?: boolean,
) => {
  const days: { [key: string]: string } = {
    Mon: "Mon",
    Tue: "Tue",
    Wed: "Wed",
    Thu: "Thu",
    Fri: "Fri",
    Sat: "Sat",
    Sun: "Sun",
  };
  const dateFormat = moment(dateTime).format("llll")?.split(",");
  const year = dateFormat[2]?.split(" ")[1];
  const time =
    dateFormat[2]?.split(" ")[2] + " " + dateFormat[2]?.split(" ")[3];
  const date = dateFormat[1]?.split(" ")[2];
  const month = dateFormat[1]?.split(" ")[1];
  const day = dateFormat[0];
  const timeZoneAbbreviation = moment.tz(moment.tz.guess()).format("z");
  if (withComma) {
    return `${date} ${month} ${year}, ${days[day]}`;
  } else if (withTime) {
    return `${date} ${month} ${year}, ${days[day]} ${time} (${timeZoneAbbreviation})`;
  } else {
    return `${date} ${month} ${year} (${days[day]})`;
  }
};

// copy to clipbord funtion
export const copyToClipboard = (ref: any, url: string, text?: string) => {
  if (ref.current && navigator.clipboard) {
    // Use the Clipboard API
    navigator.clipboard
      .writeText(url)
      .then(() => {
        showToast(text ? text : t("INVITE.COPY_SUCCESS"), "success");
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((_err) => {
        showToast(t("INVITE.COPY_FAILED"), "error");
      });
  }
};

interface Item {
  value: string | number | undefined;
  label: string;
  option?: any;
}

interface Iobject {
  value: string | number | undefined;
  label: string;
}

export async function getLabelByValue(
  arr: Item[],
  targetValue: string | number,
): Promise<Iobject | undefined> {
  const item = arr.find((item) => item.value === targetValue);
  return item ? item : undefined;
}
// decode text
export function convertToText(value: string) {
  if (value === undefined || value === null) {
    return "";
  } else {
    return atob(value);
  }
}

interface ISkillData {
  skillName: string;
  skillIcon: string;
  difficultyLevel: string;
  totalQuestions: number;
}

// manage the duplicate skill and mention the difficultyLevel
export function manageDuplicateSkills(data: ISkillData[]): any {
  if (data) {
    return (
      data.map((skill) => ({
        ...skill,
        skillName: `${skill.skillName} - ${skill.difficultyLevel}`,
      })) ?? []
    );
  } else {
    return null;
  }
}

export function extractLanguage(url: string): string | null {
  const parts = url.split("/");
  if (parts.length < 3) {
    return null; // URL doesn't have enough parts
  }
  return parts[1]; // Return the second part of the URL
}
// start edited assessment data
// transform edited assessment data
export const editedExistingformData = (DataJson: any) => {
  const existingTemplateData = {
    subjectFieldSet: DataJson?.data?.assessmentSkills?.map((item: any) => ({
      skillId: item?.skillId,
      skillIcon: item?.skillIcon,
      difficultyLevel: item?.difficultyLevel,
      title: item?.skillName,
      selectedDifficultyLevels: {
        [item?.difficultyLevel]: item?.totalQuestions,
      },
      questionType: item?.questionType,
      questionsCount: item?.totalQuestions,
      indiAssessTime: `${calculatTotalTimeOfSkill(item?.questionType, Number(item?.totalQuestions))} mins`,
    })),
    assessmentTitle: DataJson?.data?.title,
    aboutAssess: "About test 01",
    description: DataJson?.data?.description,
    skills: DataJson?.data?.assessmentSkills?.length,
    // experienceLevel: `${DataJson?.data?.minimumExperience ?? 3} Years - ${
    //   DataJson?.data?.maximumExperience ?? 5
    // } Years`,
    timeLimit: `${DataJson?.data?.totalTime} mins`,
    questions: DataJson?.data?.totalQuestions,
    assessmentId: DataJson?.data?.templateId,

    // isPublic: DataJson?.data?.isPublic,
  };

  return existingTemplateData;
};

// transform evaluation Data
const transformData = (data: any) => {
  const result: any = [];

  data.forEach((item: any) => {
    if (typeof item.attributes === "object") {
      for (const [key, value] of Object.entries(item.attributes)) {
        result.push({ type: item.type, [key]: value });
      }
    } else {
      result.push({ type: item.type, attributes: item.attributes });
    }
  });

  return result;
};

export const editedformData = async (Json: any, pathName?: string) => {
  const addedSkills = Json?.data?.assessmentSkills?.map((item: any) => {
    return {
      ...item,
      id: item.id ?? Math.random(),
      questionNo: item?.totalQuestions,
    };
  });
  // filter only skill ids
  const extractedSkillIds = addedSkills
    ?.map((item: any) => item?.skillId)
    .filter((id: string | null | undefined) => id != null);
  const skillIdsArray = JSON.stringify(extractedSkillIds);
  // api call to get difficulty levels present in given skillId array
  const getSkillsLevel = await getSkillsForLevels([skillIdsArray]);
  // modify the original skills array, if difficulty level exists but no question then assign questionNo 0.
  const skills = getSkillsLevel?.data?.data.flatMap((skill: any) => {
    const difficulties = skill.difficultyLevels.split(",");
    return difficulties.map((level: any) => {
      const matchingSkill = addedSkills.find(
        (s: any) => s.skillId === skill.skillId && s.difficultyLevel === level,
      );
      return {
        skillId: skill.skillId,
        skillName: skill.skillName,
        skillIcon: skill.icon,
        difficultyLevel: level,
        totalQuestions: matchingSkill?.totalQuestions || 0,
        questionType: skill.questionType,
        skillKeywords: [],
        id: matchingSkill?.id || Math.random(),
        questionNo: matchingSkill?.questionNo || 0,
      };
    });
  });
  // Comment for future use
  // const advanceData = {
  //   location: Json?.data?.jobLocation,
  //   engagementType: Json?.data?.engagementType,
  //   jobType: Json?.data?.jobType,
  //   disable: true,
  // };
  const transformedData = transformData(Json?.data?.evaluationTypes ?? []);
  setSessionStorageItem("evaluation", transformedData ?? []);
  setSessionStorageItem("Type", Json?.data?.assessmentTypeId || "");
  setSessionStorageItem("titleHeadContent", Json?.data?.title || "");
  setSessionStorageItem("totalQuestionTime", Json?.data?.totalTime);
  setSessionStorageItem("totalQuestionCount", Json?.data?.totalQuestions);
  if (pathName === "setting") {
    // Comment for future use

    // setSessionStorageItem("minimumExperience", Json?.data?.minimumExperience);
    // setSessionStorageItem("maximumExperience", Json?.data?.maximumExperience);
    // setSessionStorageItem("maximumResponse", Json?.data?.maxApplications);
    // setSessionStorageItem("noOfPositions", Json?.data?.totalPositions);
    setSessionStorageItem("description", Json?.data?.description);
    setSessionStorageItem("instruction", Json?.data?.instructions);
    setSessionStorageItem("cutOff", Json?.data?.cutOff);
    setSessionStorageItem("ownPreview", skills);
    // Comment for future use
    // setSessionStorageItem("advanceSettingData", advanceData);
  } else {
    // Comment for future use
    // setSessionStorageItem("maximumResponse", Json?.data?.maxApplications);
    // setSessionStorageItem("minimumExperience", Json?.data?.minimumExperience);
    // setSessionStorageItem("maximumExperience", Json?.data?.maximumExperience);
    // setSessionStorageItem("noOfPositions", Json?.data?.totalPositions);
    setSessionStorageItem("description", Json?.data?.description);
    setSessionStorageItem("instruction", Json?.data?.instructions);
    setSessionStorageItem("cutOff", Json?.data?.cutOff);
    setSessionStorageItem("cutOff", Json?.data?.cutOff);
    // Comment for future use
    // setSessionStorageItem("advanceSettingData", advanceData);

    if (Json?.data?.templateId) {
      const templateData = await getAssessmentDetailsByAssessementId(
        Json?.data?.assessmentId ?? "",
      );
      const existingPreviewData = editedExistingformData(templateData);
      // const existinData = mergeSkills(existingPreviewData);
      setSessionStorageItem("existingPreview", existingPreviewData);
    }
    const updateSkill = processData(await groupBySkillId(skills));
    setSessionStorageItem("ownPreview", updateSkill);
    setSessionStorageItem(
      "createQuestionData",
      reverseTransformAnswerSet(Json?.data?.assessmentCustomQuestions || []),
    );
  }
};

export const drafteditedformData = (Json: any, pathName?: string) => {
  const skills = Json?.createAssessmentJson?.build?.assessmentSkill?.map(
    (item: any) => {
      return {
        ...item,
        id: item?.id ?? Math.random(),
        questionNo: item?.questionNo ?? item?.totalQuestions,
      };
    },
  );
  setSessionStorageItem(
    "titleHeadContent",
    Json?.createAssessmentJson?.template?.title || "",
  );
  setSessionStorageItem(
    "totalQuestionTime",
    Json?.createAssessmentJson?.totalTime,
  );
  setSessionStorageItem(
    "totalQuestionCount",
    Json?.createAssessmentJson?.totalQuestions,
  );
  setSessionStorageItem(
    "totalCountedCredit",
    Json?.createAssessmentJson?.totalCountedCredit,
  );
  if (pathName === "setting") {
    setSessionStorageItem("ownPreview", skills || []);
    setSessionStorageItem(
      "existingPreview",
      Json?.createAssessmentJson?.template?.existingPreview || [],
    );
    setSessionStorageItem(
      "createQuestionData",
      Json?.createAssessmentJson?.custom?.AssessmentCustomQuestions || [],
    );
    // Comment for future use
    // setSessionStorageItem(
    //   "minimumExperience",
    //   Json?.createAssessmentJson?.setting?.minimumExperience,
    // );
    // setSessionStorageItem(
    //   "maximumExperience",
    //   Json?.createAssessmentJson?.setting?.maximumExperience,
    // );
    // setSessionStorageItem(
    //   "maximumResponse",
    //   Json?.createAssessmentJson?.setting?.maximumResponse,
    // );
    setSessionStorageItem(
      "description",
      Json?.createAssessmentJson?.setting?.description || "",
    );
    // Comment for future use
    // setSessionStorageItem(
    //   "noOfPositions",
    //   Json?.createAssessmentJson?.setting?.noOfPositions,
    // );
    setSessionStorageItem(
      "cutOff",
      Json?.createAssessmentJson?.setting?.cutOff,
    );
    setSessionStorageItem(
      "instruction",
      Json?.createAssessmentJson?.setting?.instructions || "",
    );
    // Comment for future use
    // setSessionStorageItem(
    //   "advanceSettingData",
    //   Json?.createAssessmentJson?.setting?.advanceSettingData || {},
    // );
  } else {
    const exixtingSkills = getSessionStorageItem("ownPreview") || [];
    const filteredSkills = skills.filter(
      (newSkill: any) =>
        !exixtingSkills.some(
          (existingSkill: any) => existingSkill.skillId === newSkill.skillId,
        ),
    );

    const updatedSkills = [...exixtingSkills, ...filteredSkills];
    setSessionStorageItem("ownPreview", updatedSkills || []);

    setSessionStorageItem(
      "existingPreview",
      Json?.createAssessmentJson?.template?.existingPreview || [],
    );
    setSessionStorageItem(
      "createQuestionData",
      Json?.createAssessmentJson?.custom?.AssessmentCustomQuestions || [],
    );
    // Comment for future use
    // setSessionStorageItem(
    //   "minimumExperience",
    //   Json?.createAssessmentJson?.setting?.minimumExperience,
    // );
    // setSessionStorageItem(
    //   "maximumExperience",
    //   Json?.createAssessmentJson?.setting?.maximumExperience,
    // );
    // setSessionStorageItem(
    //   "maximumResponse",
    //   Json?.createAssessmentJson?.setting?.maximumResponse,
    // );
    setSessionStorageItem(
      "description",
      Json?.createAssessmentJson?.setting?.description || "",
    );
    // Comment for future use

    // setSessionStorageItem(
    //   "noOfPositions",
    //   Json?.createAssessmentJson?.setting?.noOfPositions,
    // );
    setSessionStorageItem(
      "cutOff",
      Json?.createAssessmentJson?.setting?.cutOff,
    );
    setSessionStorageItem(
      "instruction",
      Json?.createAssessmentJson?.setting?.instructions || "",
    );
    // Comment for future use
    // setSessionStorageItem(
    //   "advanceSettingData",
    //   Json?.createAssessmentJson?.setting?.advanceSettingData || {},
    // );
  }
};
// transform edited custom question
export const reverseTransformAnswerSet = (updateAssessmentQuestions: any[]) => {
  const inputData = [];
  for (const item of updateAssessmentQuestions) {
    if (item.type === "Essay" || item.type === "Video") {
      inputData.push({
        ...item,
        answerSet: item.correctOptions,
        image: item.attachment || null,
        id:
          item?.id ??
          item?.reference ??
          item?.assessmentCustomQuestionId ??
          Math.random(),
      });
    } else {
      const answerSet = [];
      // Filter out options from answerOptions if their label matches any in correctOptions
      const filteredAnswerOptions = item.answerOptions.filter(
        (answerOption: any) =>
          !item.correctOptions.some(
            (correctOption: any) =>
              correctOption.option === answerOption.option,
          ),
      );

      // Populate answerSet from filteredAnswerOptions and correctOptions
      for (const option of filteredAnswerOptions) {
        answerSet.push({
          label: option.option,
          image: option.attachment || null,
          selected: false,
          id: Math.random(),
        });
      }
      for (const option of item.correctOptions) {
        answerSet.push({
          label: option.option,
          image: option.attachment || null,
          selected: true,
          id: Math.random(),
        });
      }
      inputData.push({
        ...item,
        id:
          item?.reference ?? item?.assessmentCustomQuestionId ?? Math.random(),
        question: item.question,
        type: item.type,
        timeLimit: item.timeLimit,
        answerSet,
        image: item.attachment || null,
      });
    }
  }
  return inputData;
};
// end edited assessment data

// start generate uuid
export const generateUUID = () => {
  const hexDigits = "0123456789abcdef";
  const segments = [8, 4, 4, 4, 12];

  return segments
    .map((segment) =>
      Array.from({ length: segment }, () =>
        hexDigits.charAt(Math.floor(Math.random() * 16)),
      ).join(""),
    )
    .join("-");
};
// end generate uuid
// start pascal case
export const toPascalCase = (str: string): string => {
  return str.replace(/(\w)(\w*)/g, (_, firstChar, restOfWord) => {
    return firstChar.toUpperCase() + restOfWord.toLowerCase();
  });
};
// end pascal case

// Function to detect if the browser is Safari
function isSafari() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("safari") && !ua.includes("chrome");
}
// calculate time in min, hour, month, year ago
export function getTimeDifference(
  inputTime: string,
  minuteText: string,
  hourText: string,
  dayText: string,
  monthText: string,
  yearText: string,
  agoText: string,
  justNowText: string,
) {
  const currentTime = moment();
  if (!inputTime) {
    return undefined;
  }

  let parsedTime;
  if (isSafari()) {
    // If Safari, try to format inputTime as ISO 8601 or another compatible format
    parsedTime = moment(inputTime, moment.ISO_8601);
    if (!parsedTime.isValid()) {
      // Attempt to fix the input format for Safari
      parsedTime = moment(
        inputTime.replace(/-/g, "/").replace("T", " ").split(".")[0] +
          " +00:00",
      );
    }
  } else {
    // For other browsers, rely on moment's auto parsing or ISO 8601 format
    parsedTime = moment(inputTime);
  }
  const diffMinutes = currentTime.diff(parsedTime, "minutes");
  const diffHours = currentTime.diff(parsedTime, "hours");
  const diffDays = currentTime.diff(parsedTime, "days");
  const diffMonths = currentTime.diff(parsedTime, "months");
  const diffYears = currentTime.diff(parsedTime, "years");
  if (diffMinutes < 1) {
    return `${justNowText}`;
  } else if (diffMinutes < 60) {
    return `${`${diffMinutes} ${minuteText}`} ${agoText}`;
  } else if (diffHours < 24) {
    return `${`${diffHours} ${hourText}`} ${agoText}`;
  } else if (diffDays < 30) {
    return `${`${diffDays} ${dayText}`} ${agoText}`;
  } else if (diffMonths < 12) {
    return `${`${diffMonths} ${monthText}`} ${agoText}`;
  } else {
    return `${`${diffYears} ${yearText}`} ${agoText}`;
  }
}
// checkTimeDifference
export const checkTimeDifference = (date: any) => {
  const createdTime = new Date(date).getTime();
  const currentTime = Date.now();
  const timeDifference = currentTime - createdTime;

  // Check if 24 hours (in milliseconds) have passed
  if (timeDifference >= 24 * 60 * 60 * 1000) {
    return true;
  } else {
    return false;
  }
};
// handle error while calling api
export function handleError(error: any) {
  if (error?.status === 409) {
    console.error("error", error);
  } else {
    if (error?.customMessage) {
      showToast(error?.customMessage, "error");
    } else {
      console.log("error", error);
    }
  }
}

// if we have uniqueId then use that otherwise use new
export const foundUniqueId = (id?: string | undefined | null) => {
  if (id) {
    return id;
  } else {
    const uniqueId = uuidv4();
    localStorage.setItem("tempUniqueId", uniqueId);
    return uniqueId;
  }
};

// check Unique Id Match
export const checkUniqueIdMatch = (
  firstId: string | null | undefined,
  secondId: string | null | undefined,
) => {
  return (firstId && secondId && firstId !== secondId) || false;
};

// function to active current(create assessment) navlink
export const checkActive = (
  pathname: string,
  tempUniqueId: string | undefined,
  currentLanguage: string,
): boolean => {
  const pathOptions = [
    `/${currentLanguage}/assessment/scope/${tempUniqueId}`,
    `/${currentLanguage}/assessment/settings/${tempUniqueId}`,
    `/${currentLanguage}/assessment/review/${tempUniqueId}`,
  ];
  return pathOptions.includes(pathname);
};
// fuction for add time(on the comment)
export const commentAgoTime = (
  createdAtTime: string | null | undefined,
): string => {
  if (!createdAtTime) return "0 mins ago";
  // Parse createdAt timestamp from API response
  const createdAtTimestamp = new Date(createdAtTime).getTime();
  // Get the current time
  const currentTime = new Date().getTime();
  // Calculate the time difference in milliseconds
  const timeDifference = currentTime - createdAtTimestamp;
  // Convert time difference to minutes
  const minutesAgo = Math.floor(timeDifference / (1000 * 60));
  if (timeDifference < 0) {
    return "0 mins ago";
  } else if (minutesAgo < 60) {
    return `${minutesAgo} mins ago`;
  } else if (minutesAgo < 1440) {
    // 1440 minutes in a day
    const hoursAgo = Math.floor(minutesAgo / 60);
    return `${hoursAgo} hours ago`;
  } else if (minutesAgo < 10080) {
    // 10080 minutes in a week
    const daysAgo = Math.floor(minutesAgo / 1440);
    return `${daysAgo} days ago`;
  } else if (minutesAgo < 40320) {
    // 40320 minutes in 4 weeks
    const weeksAgo = Math.floor(minutesAgo / 10080);
    return `${weeksAgo} weeks ago`;
  } else if (minutesAgo < 525600) {
    // 525600 minutes in 12 months
    const monthsAgo = Math.floor(minutesAgo / 40320);
    return `${monthsAgo} months ago`;
  } else {
    const yearsAgo = Math.floor(minutesAgo / 525600);
    return `${yearsAgo} years ago`;
  }
};
// function to convert input into floor or ceil value bsed on input fraction
export const roundNumber = (input: any) => {
  input = Number(input);
  const fractionalPart = input - Math.floor(input);
  if (fractionalPart >= 0.5) {
    return Math.ceil(input);
  } else {
    return Math.floor(input);
  }
};
// fucntion to convert First letter captial in a word
export const capitalizeFirstLetter = (str: any) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};

// this is for only we check template we are using or not in build screen
export const skillIdExistsInAnother = (assessmentData: any, data: any) => {
  // Extract skillId from the data array
  const dataSkillIds = data?.map((skill: any) => skill?.skillId);
  // Check if any skillId from subjectFieldSet exists in dataSkillIds
  const result = assessmentData?.subjectFieldSet?.some((subject: any) =>
    dataSkillIds?.includes(subject?.skillId),
  );

  return result;
};

export const handleScroll = (
  direction: string,
  skillsCardRef: any,
  scrollLength?: any,
) => {
  if (skillsCardRef.current) {
    const scrollAmount = scrollLength ? scrollLength + 800 : 800; // Adjust scroll amount as needed
    skillsCardRef.current.scrollBy({
      left: direction === "next" ? scrollAmount : -scrollAmount,
      behavior: "smooth",
    });
  }
};

export const removeDuplicatesBySkillId = (data: any) => {
  const result: any = [];
  const skillMap: any = {};
  let customItem = null;
  data.forEach(
    (item: { skillId: string | number; totalQuestions: any; key: string }) => {
      if (item.skillId) {
        if (!skillMap[item.skillId]) {
          skillMap[item.skillId] = { ...item, totalQuestions: 0 };
          result.push(skillMap[item.skillId]);
        }
        skillMap[item.skillId].totalQuestions += item.totalQuestions;
      } else {
        if (item.key === "Custom") {
          customItem = item;
        } else {
          result.push(item);
        }
      }
    },
  );
  if (customItem) {
    result.push(customItem);
  }
  return result;
};

export const groupBySkillId = async (data: any) => {
  const extractedSkillIds = data
    .map((item: any) => item?.skillId)
    .filter((id: string | null | undefined) => id != null);
  const skillIdsArray = JSON.stringify(extractedSkillIds);
  // Await the skill levels data
  const skillLevelData = await getSkillsForLevels([skillIdsArray]);
  // Map skillId to its difficultyLevels
  const skillIdToLevelsMap: Record<string, string[]> = {};
  skillLevelData?.data?.data?.forEach((item: any) => {
    skillIdToLevelsMap[item.skillId] = item.difficultyLevels
      ?.split(",")
      .map((level: string) => level.trim());
  });

  // Group and process data
  const grouped = data?.reduce((acc: any, item: any) => {
    if (!acc[item.skillId]) {
      acc[item.skillId] = {
        ...item,
        difficultyLevels: [],
        selectDifficultyLevel: {},
        selectedDifficultyLevels: {},
        skillKeywords: [],
      };
    }
    acc[item.skillId].difficultyLevels.push(item.difficultyLevel);
    acc[item.skillId].selectDifficultyLevel[item.difficultyLevel] =
      item.questionNo;
    acc[item.skillId].selectedDifficultyLevels[item.difficultyLevel] =
      item.questionNo;
    acc[item.skillId].skillKeywords.push(...item.skillKeywords);
    return acc;
  }, {});

  const wrappedData = Object.values(grouped).map((item: any) => ({
    ...item,
    difficultyLevels: item.difficultyLevels.join(","),
  }));

  const updateData = wrappedData?.map((item: any) => {
    const availableLevels = skillIdToLevelsMap[item.skillId] || [];

    // Fill missing difficulty levels with 0
    const completeSelectDifficultyLevel: Record<string, number> = {};
    availableLevels.forEach((level) => {
      completeSelectDifficultyLevel[level] =
        item.selectDifficultyLevel[level] || 0;
    });

    return {
      ...item,
      difficultyLevels: availableLevels.join(","),
      selectDifficultyLevel: completeSelectDifficultyLevel,
      selectedDifficultyLevels: { ...completeSelectDifficultyLevel },
      questionNo: Object.values(completeSelectDifficultyLevel).reduce(
        (acc: any, value: any) => acc + value,
        0,
      ),
      totalQuestions: Object.values(completeSelectDifficultyLevel).reduce(
        (acc: any, value: any) => acc + value,
        0,
      ),
    };
  });
  return updateData;
};

export function mergeSkills(data: any) {
  const { subjectFieldSet, ...rest } = data;

  const mergedSkills = subjectFieldSet?.reduce((acc: any, item: any) => {
    const existingSkill = acc.find(
      (skill: any) => skill?.skillId === item?.skillId,
    );
    if (existingSkill) {
      existingSkill.questionsCount += item.questionsCount;
      existingSkill.questionNo += item.questionsCount;

      // Sum up the indiAssessTime values
      const existingTime = parseInt(existingSkill?.indiAssessTime);
      const newTime = parseInt(item?.indiAssessTime);
      existingSkill.indiAssessTime = `${existingTime + newTime} mins`;

      // Merge selectedDifficultyLevels
      for (const [level, count] of Object.entries(
        item?.selectedDifficultyLevels,
      )) {
        if (existingSkill?.selectedDifficultyLevels[level]) {
          existingSkill.selectedDifficultyLevels[level] += count;
        } else {
          existingSkill.selectedDifficultyLevels[level] = count;
        }
      }
    } else {
      acc.push({
        ...item,
        id: Math.random(),
        selectedDifficultyLevels: { ...item.selectedDifficultyLevels },
      });
    }

    return acc;
  }, []);
  const updatemergedSkills = mergedSkills?.map((item: any) => {
    const difficulty = Object.keys(item?.selectedDifficultyLevels)?.join(",");
    return { ...item, difficultyLevels: difficulty };
  });
  return { ...rest, subjectFieldSet: updatemergedSkills };
}

export const scrollToTop = () => {
  const modalBody = document.querySelector(".modal-body");
  if (modalBody) {
    modalBody.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
};
// Function to request full-screen mode
export const enterFullScreen = () => {
  const docElm = document.documentElement as HTMLElement;
  if (docElm.requestFullscreen) {
    docElm.requestFullscreen();
  } else if ((docElm as any).mozRequestFullScreen) {
    // Firefox
    (docElm as any).mozRequestFullScreen();
  } else if ((docElm as any).webkitRequestFullscreen) {
    // Chrome, Safari and Opera
    (docElm as any).webkitRequestFullscreen();
  } else if ((docElm as any).msRequestFullscreen) {
    // IE/Edge
    (docElm as any).msRequestFullscreen();
  }
};
// Function to exit full-screen mode
export const exitFullScreen = () => {
  if (document.exitFullscreen) {
    document.exitFullscreen().catch((error) => {
      console.error("Failed to exit full-screen mode:", error);
    });
  } else if ((document as any).mozCancelFullScreen) {
    // Firefox
    (document as any).mozCancelFullScreen();
  } else if ((document as any).webkitExitFullscreen) {
    // Chrome, Safari and Opera
    (document as any).webkitExitFullscreen();
  } else if ((document as any).msExitFullscreen) {
    // IE/Edge
    (document as any).msExitFullscreen();
  }
};
//to copy email
export const copyText = (text: any) => {
  navigator.clipboard
    .writeText(text)
    .then(() => {
      showToast("Email Copied", "success");
    })
    .catch((err) => {
      console.error("Failed to copy text: ", err);
    });
};

export const countCreditCheck = (questionData: any, paymentDetails: any) => {
  const evaluationAi = getSessionStorageItem("evaluation") ?? [];
  const evaluationAiChecks = evaluationAi ?? {
    aiAnalysis: false,
    visualAnalysis: false,
    audioAnalysis: false,
  };
  const UpdateEvaluation = evaluationAiChecks
    .filter((item: any) => item.type === "smartAi")
    .reduce((acc: any, curr: any) => ({ ...acc, ...curr }), {
      type: "smartAi",
    });
  const { aiAnalysis, visualAnalysis, audioAnalysis } = UpdateEvaluation;
  const videoType = {
    type: "Video",
    unit: paymentDetails?.packageDetails?.creditForManualAnalysisVideoQuestion,
    totalQuestion: questionData
      ?.filter((ele: any) => ele?.questionType === "Video") // filter for "Video" question type
      .reduce(
        (total: number, ele: any) => total + (ele?.totalQuestions || 0),
        0,
      ),
    credit:
      questionData
        ?.filter((ele: any) => ele?.questionType === "Video") // filter for "Video" question type
        .reduce(
          (total: number, ele: any) => total + (ele?.totalQuestions || 0),
          0,
        ) *
      (paymentDetails?.packageDetails?.creditForManualAnalysisVideoQuestion +
        (aiAnalysis
          ? paymentDetails?.packageDetails?.creditForAIAnalysisVideoQuestion
          : 0) +
        (visualAnalysis
          ? paymentDetails?.packageDetails?.creditForVisualAnalysisVideoQuestion
          : 0) +
        (audioAnalysis
          ? paymentDetails?.packageDetails?.creditForVoiceAnalysisVideoQuestion
          : 0)),
  };

  const codingType = {
    type: "Coding",
    unit: paymentDetails?.packageDetails?.creditForCodingQuestion,
    totalQuestion: questionData
      ?.filter((ele: any) => ele?.questionType === "Coding") // filter for "Video" question type
      .reduce(
        (total: number, ele: any) => total + (ele?.totalQuestions || 0),
        0,
      ),
    credit:
      questionData
        ?.filter((ele: any) => ele?.questionType === "Coding") // filter for "Video" question type
        .reduce(
          (total: number, ele: any) => total + (ele?.totalQuestions || 0),
          0,
        ) * paymentDetails?.packageDetails?.creditForCodingQuestion,
  };

  const mcqEssayType = {
    type: "McqEssay",
    unit: paymentDetails?.packageDetails?.creditForMCQ,
    totalQuestion: questionData
      ?.filter(
        (ele: any) =>
          ele?.questionType === "MCQ" || ele?.questionType === "Essay",
      ) // filter for "Video" question type
      .reduce(
        (total: number, ele: any) => total + (ele?.totalQuestions || 0),
        0,
      ),
    credit:
      questionData
        ?.filter(
          (ele: any) =>
            ele?.questionType === "MCQ" || ele?.questionType === "Essay",
        ) // filter for "Video" question type
        .reduce(
          (total: number, ele: any) => total + (ele?.totalQuestions || 0),
          0,
        ) * paymentDetails?.packageDetails?.creditForMCQ,
  };

  const singleCustomType = {
    type: "Single",
    unit: paymentDetails?.packageDetails?.creditForCustomQuestion,
    totalQuestion: questionData
      ?.filter((ele: any) => ele?.type === "Single") // filter for "Video" question type
      .reduce((total: number) => total + (1 || 0), 0),
    credit:
      questionData
        ?.filter((ele: any) => ele?.type === "Single") // filter for "Video" question type
        .reduce((total: number) => total + (1 || 0), 0) *
      paymentDetails?.packageDetails?.creditForCustomQuestion,
  };

  const multipleCustomType = {
    type: "Multiple",
    unit: paymentDetails?.packageDetails?.creditForCustomQuestion,
    totalQuestion: questionData
      ?.filter((ele: any) => ele?.type === "Multiple") // filter for "Video" question type
      .reduce((total: number) => total + (1 || 0), 0),
    credit:
      questionData
        ?.filter((ele: any) => ele?.type === "Multiple") // filter for "Video" question type
        .reduce((total: number) => total + (1 || 0), 0) *
      paymentDetails?.packageDetails?.creditForCustomQuestion,
  };

  const essayCustomType = {
    type: "Essay",
    unit: paymentDetails?.packageDetails?.creditForCustomQuestion,
    totalQuestion: questionData
      ?.filter((ele: any) => ele?.type === "Essay") // filter for "Video" question type
      .reduce((total: number) => total + (1 || 0), 0),
    credit:
      questionData
        ?.filter((ele: any) => ele?.type === "Essay") // filter for "Video" question type
        .reduce((total: number) => total + (1 || 0), 0) *
      paymentDetails?.packageDetails?.creditForCustomQuestion,
  };

  const videoCustomType = {
    type: "CustomVideo",
    unit: paymentDetails?.packageDetails?.creditForCustomVideoQuestion,
    totalQuestion: questionData
      ?.filter((ele: any) => ele?.type === "Video") // filter for "Video" question type
      .reduce((total: number) => total + (1 || 0), 0),
    credit:
      questionData
        ?.filter((ele: any) => ele?.type === "Video") // filter for "Video" question type
        .reduce((total: number) => total + (1 || 0), 0) *
      paymentDetails?.packageDetails?.creditForCustomVideoQuestion,
  };
  // future use
  return {
    videoType,
    codingType,
    mcqEssayType,
    singleCustomType,
    multipleCustomType,
    essayCustomType,
    videoCustomType,
  };
};

// for discount on credit
export const finalDiscountCredit = () => {
  const paymentPackage =
    getSessionStorageItem("paymentData")?.discountPacakgeDetails;
  if (paymentPackage?.percentage === 0 || paymentPackage === null) {
    return 0;
  }
  const discountOnCredit = Math.floor(
    (getSessionStorageItem("totalCountedCredit") * paymentPackage?.percentage) /
      100,
  );
  return getSessionStorageItem("totalCountedCredit") - discountOnCredit;
};

//refs list for createProfile screen
export const refKeys = [
  "logo",
  "companyName",
  "industryType",
  "displayName",
  "websiteUrl",
  "mobile",
  "address",
  "country",
  "state",
  "city",
  "zipcode",
  "linkedin",
  "twitter",
  "facebook",
  "instagram",
  "ownerFirstName",
  "ownerLastName",
  "ownerDesignation",
  "ownerEmail",
  "ownerMobile",
];
// Scroll to half view port
export const scrollToDiv = (scrollRef: any) => {
  if (scrollRef.current) {
    // scrollRef.current.scrollIntoView({ behavior: "smooth" });
    window.scrollTo({
      top: window.innerHeight / 2, // Scroll to half of the viewport height
      behavior: "smooth", // Add smooth scrolling
    });
  }
};
// scroll to ref
export const scrollToRef = (scrollRef: any) => {
  if (scrollRef.current) {
    scrollRef.current.scrollIntoView({ behavior: "smooth" });
  }
};
// bytes to MB
export function formatBytes(bytes: any) {
  if (typeof bytes !== "number" || bytes < 0) {
    throw new Error("Input must be a non-negative number.");
  }

  const MB = bytes / (1024 * 1024);
  if (MB < 1) {
    const KB = bytes / 1024;
    return `${KB.toFixed(2)} KB`; // Round to 2 decimal places for KB
  } else {
    return `${MB.toFixed(2)} MB`; // Round to 2 decimal places for MB
  }
}
export const getLocationComponents = (components: any[], type: string) => {
  const component = components?.find((c: { types: string | any[] }) =>
    c?.types?.includes(type),
  );
  return component ? component?.longText : null;
};

// type for engagement or job type
export const typesKeyPair: any = {
  onSite: "On Site",
  hybrid: "Hybrid",
  remote: "Remote",
  fullTime: "Full Time",
  partTime: "Part Time",
  contract: "Contract",
  internship: "Internship",
};
// this function is used to update the data of create job screen in session storage after pay and scan
export const updateSessionStorage = (updateKey: string, updateValue: any) => {
  const jobDetailsData = getSessionStorageItem("jobDetailsData");
  if (jobDetailsData) {
    jobDetailsData[updateKey] = updateValue;
    setSessionStorageItem("jobDetailsData", jobDetailsData);
  }
};

// function to showMore/showLess
export const expandText = (ref: any, setIsExpanded: any, isExpanded: any) => {
  ref.current.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
  setTimeout(() => setIsExpanded(!isExpanded), 500);
};

// Function to get the truncated text (first two lines, approximated by word count)
export const getTruncatedText = (text: string, wordLimit: number) => {
  const words = text?.split(" ");
  return words?.length > wordLimit
    ? words?.slice(0, wordLimit)?.join(" ") + "..."
    : text;
};

// remove all the items of create job screen from session storage
export const removeJobDetailsData = () => {
  removeSessionStorageItem("jobDetailsData");
  removeSessionStorageItem("job-keywords");
  removeSessionStorageItem("isJobScanning");
  removeSessionStorageItem("jdText");
  removeSessionStorageItem("minimumExperience");
  removeSessionStorageItem("maximumExperience");
  removeSessionStorageItem("openPositions");
  removeSessionStorageItem("jobMutipleAddress");
  removeSessionStorageItem("advanceSettingData");
  removeSessionStorageItem("jobType");
  removeSessionStorageItem("jobLocation");
  removeSessionStorageItem("jobTitle");
  removeSessionStorageItem("jobDescription");
  removeSessionStorageItem("jobSkills");
  removeSessionStorageItem("noOfPositions");
  removeSessionStorageItem("jobAdditionalNotes");
  removeSessionStorageItem("jobShiftStartTime");
  removeSessionStorageItem("jobShiftEndTime");
  removeSessionStorageItem("jobShiftStartMeridiem");
  removeSessionStorageItem("jobShiftEndMeridiem");
};

// start -this fuction used only on SidebarCateory.tsx
const sortDifficultyLevels = (levels: any) => {
  const order = ["Beginner", "Intermediate", "Expert"];
  return levels
    .split(",")
    .sort((a: any, b: any) => order.indexOf(a.trim()) - order.indexOf(b.trim()))
    .join(",");
};

export const processData = (data: any) => {
  const updateData = (data ?? [])?.map((item: any) => ({
    ...item,
    difficultyLevels: sortDifficultyLevels(item?.difficultyLevels ?? ""),
  }));
  return updateData;
};
// End- this fuction used only on SidebarCateory.tsx

// function to set queryparams when select filters
export const setInQueryParams = (
  queryParams: any,
  key: string,
  value: any,
  navigate: any,
) => {
  queryParams.set(key, value);
  navigate(`?${queryParams.toString()}`, { replace: true });
};
// function to remove queryparams
export const removeFromQueryParams = (
  queryParams: any,
  key: string,
  navigate: any,
) => {
  queryParams.delete(key);
  navigate(`?${queryParams.toString()}`, { replace: true });
};
// function to redirect at another url
export const redirectTo = (url: any) => {
  window.open(url, "_blank");
};

// function to calculate the total tie of each skill
export const calculatTotalTimeOfSkill = (
  questionType: string,
  questionCount: number,
) => {
  const systemPreferenceQuestionTime =
    getSessionStorageItem("systemPreference");
  if (questionType === ResponseScreenEnums.QUESTION_TYPE_VIDEO) {
    return systemPreferenceQuestionTime?.questionTime?.Video * questionCount;
  } else if (questionType === ResponseScreenEnums.QUESTION_TYPE_MCQ) {
    return systemPreferenceQuestionTime?.questionTime?.MCQ * questionCount;
  } else if (questionType === ResponseScreenEnums.QUESTION_TYPE_ESSAY) {
    return systemPreferenceQuestionTime?.questionTime?.Essay * questionCount;
  } else if (questionType === ResponseScreenEnums.QUESTION_TYPE_CODING) {
    return systemPreferenceQuestionTime?.questionTime?.Coding * questionCount;
  }
};
export const linkedInConsts = {
  authUrl:
    "https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=",
  linkedInScope: "openid%20email%20profile%20w_member_social",
};

export const removeDuplicateBySkillID = (array: any) => {
  const uniqueSkills = new Map();
  array?.forEach((skill: any) => {
    const existingSkill = uniqueSkills?.get(skill?.skillId);

    if (
      !existingSkill ||
      Object.keys(skill).length > Object.keys(existingSkill).length
    ) {
      uniqueSkills.set(skill?.skillId, skill);
    }
  });

  const filteredData = Array.from(uniqueSkills.values());
  return filteredData;
};
// function to get dynamic current year
export const getCurrentYear = () => {
  return new Date().getFullYear();
};

// function to show assessment tab active
export const isAssessmentActive = (
  pathname: string,
  currentLanguage: string,
) => {
  const excludedPaths = [
    "template",
    "build",
    "custom",
    "settings",
    "review",
    "sample-questions",
  ];
  return (
    pathname.startsWith(`/${currentLanguage}/assessment`) &&
    !excludedPaths.some((subPath) =>
      pathname.match(new RegExp(`/assessment/${subPath}(/|$)`)),
    )
  );
};

// seperate date time
export function seperateDateTime(dateString: any) {
  const regex = /, [A-Za-z]{3}/;
  const formattedDate = convertDate(dateString, false, true);
  const splitIndex = formattedDate.search(regex) + 5;
  const beforeDay = formattedDate.slice(0, splitIndex);
  const afterDay = formattedDate.slice(splitIndex).trim();
  return { beforeDay, afterDay };
}

export const emailRegex =
  /^(?!.*\.{2})([a-zA-Z0-9._%+-]+)@([a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*)(?:\.[a-zA-Z]{2,})+$/;

// avg of array item
export const scoreAvg = (scores: any) => {
  if (scores.length === 0) return 0;
  const total = scores.reduce(
    (sum: any, item: any) => sum + (item.score ?? item.totalScore),
    0,
  );
  return Math.round(total / scores.length);
};
// avgrage of ai parameter in object
export const aiParametersAvg = (obj: any) => {
  const excludeKeys = ["aiConfidence", "language_and_grammar"];
  const values: any = Object?.entries(obj)
    .filter(([key]) => !excludeKeys.includes(key))
    .map(([, value]) => value);

  return Math.round(
    values.length
      ? values.reduce((sum: any, num: any) => sum + num, 0) / values.length
      : 0,
  );
};
// function to modify the api array of keywords at the time of draft
export const modifyKeywordsDataOnEdit = (data: any) => {
  const result: {
    [key: string]: { skillId: string; keywords: string; level: string[] };
  } = {};
  data?.forEach(
    ({
      skillId,
      keywords,
      level,
    }: {
      skillId: string;
      keywords: string;
      level: string | string[];
    }) => {
      if (!result[keywords]) {
        result[keywords] = { skillId, keywords, level: [] };
      }
      // Convert level to an array if it's a string
      const levels = Array.isArray(level) ? level : [level];
      // Ensure unique levels are added
      levels.forEach((lvl) => {
        if (!result[keywords].level.includes(lvl)) {
          result[keywords].level.push(lvl);
        }
      });
    },
  );
  return Object.values(result);
};

// check demo url
export const isDemo =
  process.env.REACT_APP_API === "https://demo.api.evluate.com/";

// get screen width
export const getScreenWidth = () => window.innerWidth;
export const getElementWidth = (element: HTMLElement | null) => {
  return element ? element.getBoundingClientRect().width : 0;
};

export const scrollWindowTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth", // Optional: Adds a smooth scroll effect
  });
};

export const removeMilliseconds = (timeString: string) => {
  if (!timeString) return "";
  const parts = timeString.split(":");
  if (parts?.length >= 2) {
    return `${parts[0]}:${parts[1]}`;
  }
  return timeString;
};

export const formatSummaryTitle = (str: string) => {
  return str
    .split("_") // Split the string by underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join with space
};

// format address of job creation for payload
export const formatAddressField = (addressfield: any) => {
  return addressfield.map((item: any) => ({
    addressLine1: item.addressLine1,
    addressLine2: item.addressLine2,
    country: item.country.value,
    state: item.state.value,
    city: item.city,
    zipcode: item.zipcode,
    geoCordinates: [
      item.coordinates.latitude.toString(),
      item.coordinates.longitude.toString(),
    ],
  }));
};

// format the response of addressfield from api
export const transformJobDetails = (jobDetails: any) => {
  return jobDetails?.map((job: any) => {
    const [latitude, longitude] = JSON.parse(job.geoCordinates);
    return {
      addressLine1: job.addressLine1,
      addressLine2: job.addressLine2,
      country: {
        value: job.countryName.countryId,
        label: job.countryName.country,
      },
      state: {
        value: job.stateName.stateId,
        label: job.stateName.state,
      },
      city: job.city,
      zipcode: job.zipcode,
      coordinates: {
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
      },
      id: `${job.addressLine1}-${job.city}-${job.stateName.stateId}-${job.zipcode}`,
    };
  });
};

// function to validate shift time
export const validateShiftTime = (
  startTime: string,
  startMeridiem: string,
  endTime: string,
  endMeridiem: string,
): { isValid: boolean; errorMessage?: string } => {
  // Parse time components
  const startHour = parseInt(startTime.split(":")[0]);
  const startMinute = parseInt(startTime.split(":")[1] || "0");
  const endHour = parseInt(endTime.split(":")[0]);
  const endMinute = parseInt(endTime.split(":")[1] || "0");

  // Validate input values
  if (
    isNaN(startHour) ||
    isNaN(startMinute) ||
    isNaN(endHour) ||
    isNaN(endMinute)
  ) {
    return {
      isValid: false,
      errorMessage: "Invalid time format",
    };
  }

  if (startHour < 1 || startHour > 12 || endHour < 1 || endHour > 12) {
    return {
      isValid: false,
      errorMessage: "Hours must be between 1 and 12",
    };
  }

  if (startMinute < 0 || startMinute > 59 || endMinute < 0 || endMinute > 59) {
    return {
      isValid: false,
      errorMessage: "Minutes must be between 0 and 59",
    };
  }

  // Convert to 24-hour format for comparison
  let start24Hour = startHour;
  if (startMeridiem === "PM" && startHour < 12) {
    start24Hour += 12;
  } else if (startMeridiem === "AM" && startHour === 12) {
    start24Hour = 0;
  }

  let end24Hour = endHour;
  if (endMeridiem === "PM" && endHour < 12) {
    end24Hour += 12;
  } else if (endMeridiem === "AM" && endHour === 12) {
    end24Hour = 0;
  }

  // Compare times
  if (
    start24Hour > end24Hour ||
    (start24Hour === end24Hour && startMinute >= endMinute)
  ) {
    return {
      isValid: false,
      errorMessage: "Invalid shift time",
    };
  }

  return { isValid: true };
};
// function for returning create contract initial values
export const createContractInitialValues = (t: any) => {
  return {
    contractTitle: "",
    contractType: t("CONTRACT.HOURLY"),
    startDate: "",
    duration: "",
    durationType: "Months",
    noticePeriodDays: 30,
    rate: "",
    currencyType: "",
    currencyUnit: "Monthly",
    paymentTerms: "net 30",
    billingCycle: "Monthly",
    contractStartTime: "10:00",
    contractEndTime: "7:00",
    timezone: "IST",
    contractTerms: "",
    contractStartMeridiem: "AM",
    contractEndMeridiem: "PM",
  };
};

// format the url where https:// is not present
export const formatUrl = (url: string) => {
  if (!url) return "#";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `https://${url}`;
};

// function to check string contains substring
export const checkStringContainsSubStr = (
  mainString: string,
  substrings: string[],
) => {
  const lowerMain = mainString.toLowerCase();
  return substrings.some((sub: any) => lowerMain.includes(sub.toLowerCase()));
};
// function to download a document
export const handleDownloadDocument = async (url: string, name?: string) => {
  if (!url) {
    console.warn("CV URL not available for download.");
    return;
  }
  try {
    // If name is provided, force file download using fetch (supports all file types)
    if (name) {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } else {
      // Just open/download the file without custom name
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("File download failed:", error);
  }
};

// masking function
export const maskClientId = (clientId: string, show: boolean): string => {
  if (!clientId) return "";

  if (show) return clientId;

  // Mask middle part
  const start = clientId.slice(0, 4);
  const end = clientId.slice(-4);
  const masked = "*".repeat(Math.max(0, clientId.length - 8));

  return `${start}${masked}${end}`;
};

// get crrent browser
export const getBrowserName = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes("Firefox/")) return "Firefox";
  if (userAgent.includes("Edg/")) return "Edge";
  if (userAgent.includes("OPR/") || userAgent.includes("Opera")) return "Opera";
  if (
    userAgent.includes("Chrome/") &&
    !userAgent.includes("Edg/") &&
    !userAgent.includes("OPR/")
  )
    return "Chrome";
  if (userAgent.includes("Safari/") && !userAgent.includes("Chrome/"))
    return "Safari";

  return "Unknown";
};
// get ip
export const geoLocationapiClient = async () => {
  try {
    const res: any = await getEntireCustomUrl(
      "https://api.ipify.org?format=json",
    );
    return res;
  } catch (err) {
    console.error(err);
    return null;
  }
};

// get splitted cdn url after .net/
export const getSplittedCdnUrl = (url: string): string => {
  const splitIndex = url.indexOf(".net/");
  if (splitIndex === -1) return url; // if ".net/" not found, return whole url
  return url.substring(splitIndex + 5); // +5 to skip ".net/"
};

//  play sound on notification
export const playNotificationSound = () => {
  try {
    const audio = new Audio("/Sounds/NotficationSound.mp3");
    audio.play().catch((err) => {
      console.warn("Audio autoplay blocked in SW:", err);
    });
  } catch (e) {
    console.error("Error playing sound:", e);
  }
};

// logout function
export const handleLogout = (navigate: any) => {
  APIClient.setApiToken("");
  localStorage.removeItem("sessionId");
  localStorage.removeItem("companyToken");
  localStorage.removeItem("companyId");
  localStorage.removeItem("industryId");
  localStorage.removeItem("tempUniqueId");
  localStorage.removeItem("mediaPath");
  localStorage.removeItem("companyUserId");
  localStorage.removeItem("email");
  localStorage.removeItem("companyAddress");
  localStorage.removeItem("branchId");
  localStorage.removeItem("jobShareAddedEmail");
  localStorage.removeItem("CurrentMainVerified");
  localStorage.removeItem("jobShareSelectedEmail");
  localStorage.removeItem("ipAddress");
  localStorage.removeItem("fcmToken");
  sessionStorage.clear();
  navigate("/");
};

// Score format
export const formatScore = (score: number | null | undefined) => {
  return score != null ? `${Math.round(score)} / 100` : "0 / 100";
};
